import React from 'react';
import { CardTitle } from './Card';

/**
 * Standard card list header: title on the left,
 * search / filters / primary actions on the right (stacked on small screens).
 * Use tone="light" with CardHeader variant="gradient" (same bar as modal headers).
 */
export function CardListToolbar({ left, title, subtitle, actions, tone = 'dark', className = '' }) {
  const onLight = tone === 'light';

  const titleBlock =
    title != null ? (
      <div className="min-w-0">
        {onLight ? (
          <h3 className="text-base font-semibold tracking-tight text-white sm:text-lg">{title}</h3>
        ) : (
          <CardTitle>{title}</CardTitle>
        )}
        {subtitle ? (
          <p className={`mt-0.5 text-sm ${onLight ? 'text-white/80' : 'text-slate-500'}`}>{subtitle}</p>
        ) : null}
      </div>
    ) : null;

  const leftBlock =
    left != null ? (
      onLight ? (
        <div className="min-w-0 text-white [&_h3]:text-white [&_p]:text-white/85">{left}</div>
      ) : (
        left
      )
    ) : (
      titleBlock
    );

  return (
    <div className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between ${className}`}>
      {leftBlock}
      {actions ? (
        <div className="flex w-full flex-col items-stretch gap-2 sm:w-auto sm:flex-row sm:items-center">
          {actions}
        </div>
      ) : null}
    </div>
  );
}

export default CardListToolbar;
